
<script>

///Ultima alteração: 10/06/2020
///Alterado por: Allinne   

    export let type		= null;
    export let urlLink  = encodeURI(document.location);

    const defaultValues = {
        'Twitter': {
            name: 'Twitter',
            title: 'Compartilhe no Twitter',
            icon: '<i class="fab fa-twitter"></i>',
            link: 'https://twitter.com/share?url=' + urlLink,
        },
        'Facebook': {
            name: 'Facebook',
            title: 'Compartilhe no Facebook',
            icon: '<i class="fab fa-facebook-f"></i>',
            link: 'https://www.facebook.com/sharer/sharer.php?u=' + urlLink,
        },
        'WhatsApp': {
            name: 'WhatsApp',
            title: 'Compartilhe no WhatsApp',
            icon: '<i class="fab fa-whatsapp"></i>',
            link: 'https://api.whatsapp.com/send?text=' + urlLink,
        },
    };

	export let name		= defaultValues[type] ? defaultValues[type].name : '';
	export let title	= defaultValues[type] ? defaultValues[type].title : '';
	export let icon		= defaultValues[type] ? defaultValues[type].icon : '';
	export let link		= defaultValues[type] ? defaultValues[type].link : '';
</script>

<div class="share-item share-item--{name}" >
    <a href="{link}" title="{title}" target="_blank">
        {@html icon} {name}
    </a>
</div>

<style type="text/sass">

.share-item 
    display: inline-block
    vertical-align: top
    margin: .3em .6em .3em 0
    &.share-item--Facebook 
        a
            color: #3b5998
    &.share-item--WhatsApp 
        a
            color: #29a628
    &.share-item--Twitter 
        a
            color: #00aced
</style>